import type {
  ApiEndpointQuery,
  EndpointDefinitions,
  QueryActionCreatorResult,
  QueryArgFrom,
  QueryDefinition,
  StartQueryActionCreatorOptions,
} from '@reduxjs/toolkit/query'

import type {AppThunk} from '../actions/types'

export type AnyQueryDefinition = QueryDefinition<any, any, any, any, any>
export type Endpoint<D extends AnyQueryDefinition> = ApiEndpointQuery<D, EndpointDefinitions> & {
  useQuerySubscription(arg: QueryArgFrom<D>): unknown
}

export type LoadedEndpoint<D extends AnyQueryDefinition = AnyQueryDefinition> = {
  endpoint: Endpoint<D>
  arg: QueryArgFrom<D>
  result: QueryActionCreatorResult<D>
}
export const loadEndpoint =
  <D extends AnyQueryDefinition>(
    endpoint: Endpoint<D>,
    arg: QueryArgFrom<D>,
    options?: StartQueryActionCreatorOptions,
  ): AppThunk<LoadedEndpoint<D>> =>
  dispatch => ({
    endpoint,
    arg,
    result: dispatch(endpoint.initiate(arg, {subscribe: false, ...options})),
  })

export type LoadedEndpoints = Array<LoadedEndpoint | null | undefined | false | 0 | ''>

export type PreloadedEndpointsLoaderData = {
  preloadedEndpoints?: LoadedEndpoints
}
